var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"animated fadeIn"},[_c('b-tabs',[_c('b-tab',{attrs:{"title":"Samples"}},[_c('SubmissionSampleTable',{attrs:{"submission":_vm.submission}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }